import { DateTime } from 'luxon';

export type TParams = { agencyId: string; tab: string };

export const statusConfig: { value: 'active' | 'archived'; label: string }[] = [
  { value: 'active', label: 'Active' },
  { value: 'archived', label: 'Archived' },
];

export const isNumberField = (fields: string[], value: string) => {
  if (fields.includes(value)) {
    return true;
  }

  return false;
};

export const formatDate = (date?: DateTime) => {
  if (!date) return '';
  return DateTime.fromJSDate(new Date(date.toString())).toLocaleString(DateTime.DATETIME_SHORT);
};
